import { useContentfulTranslations } from "@/utils/contentfulTranslations";
import { useLocale } from "@/hooks/useLocale";

const PageThanks = () => {
  const { successText } = useContentfulTranslations();
  const locale = useLocale();

  return (
    <div className="flex justify-center items-center">
      <div className="w-full max-w-md text-center">
        <h3 className="text-lg font-semibold !text-[24px] text-gray-800">
          <span
            className="font-[HelveticaRoman,_Helvetica,_sans-serif]"
            dangerouslySetInnerHTML={{ __html: successText?.[locale] }}
          />
        </h3>
      </div>
    </div>
  );
};

export default PageThanks;
